<template>
  <layout-full>
    <router-view />
  </layout-full>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import LayoutFull from '@/layouts/layout-full/LayoutFull.vue';

export default defineComponent({
  components: {
    LayoutFull,
  },

  setup() {
    return {};
  },
});
</script>
